import { render, staticRenderFns } from "./contato.vue?vue&type=template&id=a8aca4ac&"
import script from "./contato.vue?vue&type=script&lang=js&"
export * from "./contato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports